import type { TimeOffset } from '@travelity/api/generated';

export const formatTimeOffset = (timeOffset: TimeOffset): string => {
    const hh = String(timeOffset.hours).padStart(2, '0');
    const mm = String(timeOffset.minutes).padStart(2, '0');

    return `${hh}:${mm}`;
};
